import { DEFAULT_LOCALE, PRIMARY_LANG } from '@constants/langs';

export const getLocale = (locale) => (locale === DEFAULT_LOCALE ? PRIMARY_LANG.value : locale);
